<header class="mast-main-head fixed-top">

  <!-- <div class="main-header-subscriber-offer-section">
    <span>🎉 Celebratings! <strong>50k+</strong> users & <strong>2K+</strong> happy subscribers.<b routerLink="/happy-subscribers"> What's in? </b> <img class="arrow" src="assets/img/arrow-right.svg" alt=""> <img class="illus-img" src="assets/img/online-cab.png" alt=""> <img class="illus-img" src="assets/img/team-art.svg" alt=""> <img class="illus-img" src="assets/img/yoga.png" alt=""></span></div> -->

    <nav class="navbar navbar-expand-lg remove-shadow" id="mainNav">
    <div class="container">
      <a class="navbar-brand js-scroll-trigger" href="javascript:;" routerLink="/home"><img src="assets/img/logo.svg"></a>
      <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
      </button>
      <div class="collapse navbar-collapse" id="navbarResponsive">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <a class="nav-link marketplace" routerLink="/how-it-works" style="cursor: pointer;">How it works</a>
        </li>
        <li class="nav-item">
          <a class="nav-link marketplace" (click)="openMarketplace()" style="cursor: pointer;">Marketplace</a>
        </li>
        <li class="nav-item">
          <a class="nav-link marketplace" routerLink="/pricing">Pricing</a>
        </li>
        <li class="nav-item dropdown col-1-dropdown">
          <a class="nav-link dropdown-toggle marketplace" data-toggle="dropdown">Plugins</a>
          <div class="dropdown-menu" style="width: 200px;">
            <ul>
              <li><a style="color: #000" class="nav-link" href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">
                <img src="assets/img/ic-figma.png" alt=""> <span>Figma</span> </a>
                <!-- <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="Icons/Navigation/Arrow Down/Black">
                    <g id="Group">
                      <path id="down_arrow" d="M18.5 9.44444L12.3274 15L6 9.57345" stroke="#b2b2b2" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                  </g>
                </svg> -->
              </li>
              <li><a style="color: #000" class="nav-link" href="https://crafttor.com/sketch" target="_blank">
                <img src="assets/img/ic-sketch.png" alt=""> <span>Sketch</span> </a></li>
              <li><a style="color: #000" class="nav-link" href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">
                <img src="assets/img/ai.png" alt="" style="width: 20px; height: 20px; margin-left: 4px;"> <span>Illustrator</span> </a></li>
            </ul>
          </div>
        </li>
        <li class="nav-item">
          <a class="nav-link marketplace" href="https://crafttor.com/blogs" target="_blank">Blog</a>
        </li>
         <li class="nav-item signup-btn">
        <a class="nav-link button" data-toggle="modal" routerLink="/login">Start for free</a>
        </li>
        <li class="nav-item login-btn">
        </li>
      </ul>
      </div>
    </div>
  </nav>
</header>

<section class="feedback-section-header">
	<div class="container">
		<div class="row">
			<div class="col-sm-12">
				<div class="inner-content">
					<h1>Your feedback 🤩</h1>
          <p>Welcome to our feedback page, where your opinion matters! We believe that the best way to enhance your experience is by listening to you. Your feedback is the compass that guides our journey towards providing you with the best possible experience. We're eager to hear your thoughts.</p>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="feedback-section">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <p class="feedback-content">We would love your feedback to serve you better.❤️</p>
        <div class="col-sm-12 feedback-imgs">
          <!-- <div class="col-sm-4"></div> -->
          <ul class="feedback">
            <li class="Very-Sad" (click)="ratingEmoji(1)"></li>
            <li class="Sad" (click)="ratingEmoji(2)"></li>
            <li class="Okay" (click)="ratingEmoji(3)"></li>
            <li class="Happy" (click)="ratingEmoji(4)"></li>
            <li class="Very-Happy" (click)="ratingEmoji(5)"></li>
          </ul>
        </div>

        <h6>{{feedbackMessage}} {{feedbackEmoji}}</h6>

        <form class="form-horizontal" [formGroup]="feedbackForm" (ngSubmit)="submitFeedbackForm()">
          <div class="form-group">
            <div class="col_full">
              <input id="textinput" formControlName="name" maxlength="200" type="text" placeholder="Full name" class="form-control input-md">
              <input id="textinput" formControlName="email" maxlength="200" type="text" placeholder="Email Id" class="form-control input-md">
              <input id="textinput" formControlName="msg" maxlength="200" type="text" placeholder="Add a feedback message..." class="form-control input-md">
            </div>
          </div>
          <button *ngIf="showFeedbackLoader" id="singlebutton" name="singlebutton button" class="btn btn-primary"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
          <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="!showFeedbackLoader" style="font-weight: 500;">Submit</button>
        </form>
      </div>
    </div>
  </div>
</section>

<section class="customer-feedbacks">
  <h3 class="main-title" *ngIf="feedbackList.length > 0">What our customer's feedbacks</h3>
  <div class="container">
    <div class="row">
      <ul *ngFor="let feedbacks of feedbackList | slice:0:3">
        <li>
          <div class="review-icon-box">

          </div>
          <p class="feedback-msg">{{feedbacks.message}}</p>

          <div class="review-img-box">
            <hr class="hr-border">
            <div class="review-img">
              <p class="feedback-name">{{feedbacks.first_name}} <br>
                <span class="ratings" *ngIf="feedbacks.rating == 1">Ver bad</span>
                <span class="ratings" *ngIf="feedbacks.rating == 2">Poor</span>
                <span class="ratings"  *ngIf="feedbacks.rating == 3">Medium</span>
                <span class="ratings"  *ngIf="feedbacks.rating == 4">Good</span>
                <span class="ratings"  *ngIf="feedbacks.rating == 5">Excellent</span>
              </p>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</section>

<section class="newsletter-form-section">
	<div class="container">
		<div class="row">
			<div class="col-sm-12">
				<div class="form-news">
					<div class="thumb"><img src="assets/img/mail-box.png"></div>
					<div class="desc">
						<h2>Any suggestions?</h2>
            <p>We welcome your thoughts on how we can enhance your experience, whether it's a new feature, an improvement to an existing one, or any other idea that can make your interactions with us even better. Your input guides our development and ensures we continue to exceed your expectations. Thank you for being an essential part of our journey towards excellence. Please feel free to share your suggestions with us, and together, we'll shape a brighter future.</p>
            <i><h4>Email us at <a href="mailto:info@crafttor.com"><i aria-hidden="true"></i>info@crafttor.com</a></h4></i>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="feedback-section-love-suggestions">
	<div class="container">
  	<div class="row">
  		<div class="col-sm-12">
  			<div class="form-news">
  				<!-- <p>We would love your suggestions!! ❤️</p> -->
  		  </div>
  	  </div>
    </div>
  </div>
</section>

<!-- Footer -->
<footer class="site-footer">
  <div class="container">
  <div class="row">
    <div class="col-sm-3">
      <div class="coulmn-1">
				<img src="assets/img/logo.svg">
				<p>Digital assets management</p>
				<a href="mailto:info@crafttor.com"><i class="fa fa-envelope" aria-hidden="true"></i> info@crafttor.com</a>
			</div>
    </div>
    <!-- 3 -->
    <div class="col-sm-2">
      <h5>Products</h5>
      <ul class="menu">
        <li><a routerLink="/home">Workspace</a></li>
        <li><a (click)="openMarketplace()">Marketplace</a></li>
        <li><a routerLink="/features">Features</a></li>
        <li><a routerLink="/mobile-apps">Crafttor for Mobile</a></li>
<li><a routerLink="/smart-storage">Smart storage</a></li>
        <li><a routerLink="/effective-search">Effective search</a></li>

      </ul>
    </div>

    <div class="col-sm-2">
      <h5>Plugins</h5>
      <ul class="menu">
        <li><a href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">Figma</a></li>
        <li><a href="https://crafttor.com/sketch" target="_blank">Sketch</a></li>
        <li><a href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">Illustrator</a></li>
        <li><a href="https://www.figma.com/community/plugin/1408354139656199596/kaleidoscope" target="_blank">Kaleidoscope</a></li>
        <li><a href="https://www.figma.com/community/plugin/1406167507218530657/iso-all" target="_blank">Iso All</a></li>
        <li><a href="https://www.figma.com/community/plugin/1409844094149025473/translate-ai" target="_blank">Translate AI</a></li>
        <li><a href="https://www.figma.com/community/plugin/1417763374654877658/image-to-figma-design-beta" target="_blank">Image to Figma</a></li>
<li><a href="https://www.figma.com/community/plugin/1409553168281102402/bannners" target="_blank">Bannners</a></li>
      </ul>
    </div>

    <div class="col-sm-2">
      <h5>Solutions</h5>
      <ul class="menu">
        <li><a routerLink="/dropbox-alternative">Dropbox alternative</a></li>
        <li><a routerLink="/google-drive-alternative">G Drive alternative</a></li>
        <li><a routerLink="/box-alternative">Box alternative</a></li>
        <li><a routerLink="/content-library">Content library</a></li>
        <li><a routerLink="/user-profiling">User Profiling</a></li>
<li><a routerLink="/approvals">Creative approvals</a></li>
      </ul>
    </div>

    <div class="col-sm-2">
      <h5>Features</h5>
      <ul class="menu">
        <li><a routerLink="/features/tagging">Tagging</a></li>
        <li><a routerLink="/features/sharing">Sharing</a></li>
        <li><a routerLink="/features/versioning">Versioning</a></li>
        <li><a routerLink="/features/collaboration">Collaboration</a></li>
        <li><a routerLink="/features/integration">Integration</a></li>
      </ul>
    </div>

    <div class="col-sm-2">
      <h5>Company</h5>
      <ul class="menu">
        <li><a routerLink="/about-workspace">About Workspace</a></li>
        <li><a routerLink="/contact">Contact Us</a></li>
        <li><a routerLink="/terms">Terms & Conditions</a></li>
        <li><a routerLink="/faq">FAQ</a></li>
        <li><a routerLink="/feedbacks">Feedback</a></li>
        <li><a href="https://crafttor.com/blogs" target="_blank">Blog</a></li>
        <li><a routerLink="/our-mission">Our mission</a></li>
        <li><a routerLink="/partner-with-us">Partner with us</a></li>
      </ul>
    </div>

    <div class="col-sm-3 all-social-icons">
      <h5>Socials</h5>
				<ul class="social-icons">
					<li><a rel="nofollow" href="https://www.facebook.com/Crafttor-Studio-102023868185724/?modal=admin_todo_tour" target=”_blank”
            alt="facebook"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
					<li><a rel="nofollow" href="https://twitter.com/CrafttorS" target=”_blank” alt="twitter"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
					<li><a rel="nofollow" href="https://www.linkedin.com/company/crafttor/" target=”_blank” alt="linkedin"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
					<li><a rel="nofollow" href="https://www.instagram.com/crafttorstudio/" target=”_blank” alt="instagram"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
					<li><a rel="nofollow" href="https://www.youtube.com/channel/UC6SM1D8MU7uwLVEC8uFDW-w/?guided_help_flow=5" target=”_blank” alt="youtube"><i class="fa fa-youtube-play" aria-hidden="true"></i></a></li>
					<li><a rel="nofollow" href="https://dribbble.com/crafttorstudio" target=”_blank” alt="dribbble"><i class="fa fa-dribbble" aria-hidden="true"></i></a></li>
					<li><a rel="nofollow" href="https://www.behance.net/crafttorstudio" target=”_blank” alt="behance"><i class="fa fa-behance" aria-hidden="true"></i></a></li>
				</ul>
    </div>

    <div class="col-sm-12 text-center">
			<small>&copy; 2025 Crafttor. All rights reserved</small>
		</div>
  </div>
  </div>
</footer>
